<div class="b-button-group" [ngClass]="
       {
         'b-button-group--is-narrow': isNarrow,
         'b-button-group--full-height': fullHeight
       }
">
  <ng-content select="[w-button],.b-button,f-facet[name=button],[facet-button]" description="block of buttons"></ng-content>
</div>
